import React, { useState, useEffect } from 'react';
import { updateClass, getClassDetails } from '../../Api'; // Funções da API para obter e atualizar os detalhes do funcionário
import { useNavigate } from 'react-router-dom';
import {
    Container,
    InputArea,
    ToGoBack,
    Input,
    Select,
    Btt01,
    SignMessageButtonText,
    SignMessageButtonTextBold,
    ErrorMessage
} from './style';
import LoadingSpinner from '../../components/Loading';

const EditProfile = () => {
    const navigate = useNavigate();
    const [cla$$, setCla$$] = useState({});
    const [serie, setSerie] = useState('');
    const [name, setName] = useState('');
    const [level, setLevel] = useState('');
    const [shift, setShift] = useState('');
    const [classroom_number, setClassroom_number] = useState('');
    const [assessmentFormat, setassessmentFormat] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        (async () => {
            setLoading(true);
            const idStudent = sessionStorage.getItem("ClassInformation");
            const assessmentFormat = sessionStorage.getItem("assessmentFormat");
            setassessmentFormat(assessmentFormat)
            const res = await getClassDetails(idStudent);
            console.log("getClass", res.data)
            setCla$$(res.data);
            setSerie(res.data.serie || '');
            setName(res.data.name || '');
            setLevel(res.data.level || '');
            setShift(res.data.shift || '');
            setClassroom_number(res.data.classroom_number || '');
            setLoading(false);
        })();
    }, []);

    const handleSubmit = async () => {
        if (!serie || !level || !shift || !classroom_number) {
            setErrorMessage('Todos os campos devem ser preenchidos.');
            return;
        }
        setLoading(true);
        const res = await updateClass(
            cla$$._id,
            serie.toUpperCase(),
            name.toUpperCase(),
            level.toUpperCase(),
            shift.toUpperCase(),
            classroom_number
        );

        if (res) {
            alert('Turma atualizado com sucesso!');
            navigate(-1); // Redireciona para o dashboard após a atualização
        } else {
            setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
        }
        setLoading(false);
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container>
            {loading ?
                <LoadingSpinner />
                :
                <>
                    <h2>Edição de Truma</h2>
                    <InputArea>
                        <label>Série</label>
                        <Select
                            value={serie}
                            onChange={(e) => setSerie(e.target.value)}
                        >
                            <option value="">Selecione a série</option>

                            {assessmentFormat === "grade" && (
                                <>
                                    <option value="1º ANO">1º ANO</option>
                                    <option value="2º ANO">2º ANO</option>
                                    <option value="3º ANO">3º ANO</option>
                                    <option value="4º ANO">4º ANO</option>
                                    <option value="5º ANO">5º ANO</option>
                                </>
                            )}

                            {assessmentFormat === "concept" && (
                                <>
                                    <option value="MATERNAL">MATERNAL</option>
                                    <option value="1º PERÍODO">1º PERÍODO</option>
                                    <option value="2º PERÍODO">2º PERÍODO</option>
                                </>
                            )}
                        </Select>
                        <label>Nome</label>
                        <Input
                            placeholder="Ex: 5º ANO 01 ZIRALDO MATUT."
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <label>Etapa de ensino</label>
                        <Select
                            id="shift"
                            value={level}
                            onChange={(e) => setLevel(e.target.value)}
                        >
                            <option value="">Selecione</option>
                            {assessmentFormat === "concept" && (
                                <option value="EDUCAÇÃO INFANTIL">Educação Infantil</option>
                            )}
                            {assessmentFormat === "grade" && (
                                <option value="ENSINO FUNDAMENTAL">Ensino Fundamental</option>
                            )}
                        </Select>
                        <label>Turno</label>
                        <Select
                            id="shift"
                            value={shift}
                            onChange={(e) => setShift(e.target.value)}
                        >
                            <option value="">Selecione</option>
                            <option value="MATUTINO">Matutino</option>
                            <option value="VESPERTINO">Vespertino</option>
                            <option value="NOTURNO">Noturno</option>
                        </Select>
                        {/*<label>Número da Sala</label>
                        <Input
                            placeholder="Digite o número da sala"
                            value={classroom_number}
                            onChange={(e) => setClassroom_number(e.target.value)}
                        />*/}
                        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                        <Btt01 onClick={handleSubmit}>Salvar Alterações</Btt01>
                        <ToGoBack onClick={handleGoBack}>
                            <SignMessageButtonText>Voltar ao</SignMessageButtonText>
                            <SignMessageButtonTextBold>Dashboard</SignMessageButtonTextBold>
                        </ToGoBack>
                    </InputArea>
                </>
            }
        </Container>
    );
};

export default EditProfile;
